export default "__VITE_ASSET__BQ7IuQ6S__"